import { BellDot, Settings } from "lucide-react";
import { useSelector } from "react-redux";
import React from "react";

const Header = ({ clases }) => {
  const loginSuccess = useSelector((state) => state.auth?.loginSuccess);

  const username = loginSuccess?.data?.username || "Super Admin";
  const email = loginSuccess?.data?.email || "";

  return (
    <div className="border-b border-border sticky top-0 h-fit bg-white z-50">
      <div
        className={`flex flex-col lg:flex-row lg:justify-between items-center py-7 ${clases}`}
      >
        <div className="text-center lg:text-left">
          <p className="font-popinsBold text-2xl">Hello {username}</p>
          <p className="text-textColor font-popinsRegular text-sm">
            {email || "Manage and monitor the TCCplus platform."}
          </p>
        </div>
        <div className="flex items-center gap-x-10 mt-4 lg:mt-0">
          <Settings className="text-themeColor cursor-pointer text-xl lg:text-3xl" />
          <BellDot className="text-secondary cursor-pointer text-xl lg:text-3xl" />
          <div className="bg-themeColor p-2.5 rounded-full cursor-pointer">
            <img src="/assets/images/icons/admin-user.svg" className="size-5 lg:size-6" alt="Admin" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
